export default {
  articles: {
    breadcrumbHome: "Strona główna",
    breadcrumbGuides: "Poradniki",
    author: "Zespół redakcyjny USFansLink",
    readingTime: "7 min czytania",
    lastUpdated: "Ostatnia aktualizacja: sierpień 2026",
    notFound: "Nie znaleziono poradnika",
    tocTitle: "Spis treści",
    s1Title: "Dlaczego ten temat ma znaczenie",
    s1Body:
      "Każdy element procesu researchu USFans, od list produktów po szczegóły wysyłki, wpływa na decyzje, które podejmujesz przed zakupem. Gdy rozumiesz, jak ten element pasuje do szerszego obrazu, możesz pewniej porównywać opcje i unikać późniejszych niespodzianek.",
    s2Title: "Jak zacząć",
    s2Body:
      "Zacznij od kategorii lub kolumn, które są dla Ciebie najważniejsze, a następnie zawężaj wyniki krok po kroku. Proste, powtarzalne podejście — przejrzyj, porównaj, a potem potwierdź szczegóły — utrzymuje research w porządku i ułatwia dostrzeżenie informacji, których naprawdę potrzebujesz.",
    s3Title: "O czym pamiętać",
    s3Body:
      "Szczegóły mogą się zmieniać, a nie każda opcja działa tak samo. Sprawdź dwukrotnie najnowsze notatki, potwierdź informacje o wysyłce i płatności oraz zachowaj ostrożność przy wszystkim, co wygląda nietypowo. Kilka dodatkowych minut na początku zwykle oszczędza czas i kłopoty później.",
    faqTitle: "Często zadawane pytania",
    faq: [
      {
        q: "Czy ten poradnik jest aktualizowany?",
        a: "Regularnie przeglądamy i odświeżamy nasze poradniki, ale szczegóły, takie jak koszty wysyłki i oferty, mogą się szybko zmieniać, dlatego zawsze potwierdzaj najnowsze informacje w sklepie przed zakupem.",
      },
      {
        q: "Czy potrzebuję konta, aby korzystać z tych informacji?",
        a: "Nie, większość poradników i zasobów jest darmowa do czytania. Może być konieczne zalogowanie się, aby dokończyć zakup w głównym sklepie.",
      },
      {
        q: "Gdzie znajdę więcej zasobów USFans?",
        a: "Przeglądaj powiązane poradniki na tej stronie lub wróć na stronę główną USFansLink, aby poznać pełen zestaw zasobów.",
      },
    ],
    relatedTitle: "Powiązane zasoby USFans",
    relatedIntro: "Kontynuuj eksplorację z powiązanymi poradnikami i zasobami.",
    relatedHome: "Powrót na stronę główną USFansLink",
    relatedGuide: "Kompletny przewodnik po arkuszu USFans",
    conclusionTitle: "Kontynuuj research USFans",
    conclusionBody:
      "Wykorzystaj to, czego się tutaj nauczyłeś, aby pewniej kontynuować research i eksplorować uporządkowane kategorie i poradniki, kiedy będziesz gotowy.",
    cta: "Poznaj arkusz USFans",
    backHome: "Powrót na stronę główną",
    disclaimer:
      "Ten poradnik jest niezależnym źródłem informacyjnym i nie jest powiązany z USFans ani przez niego zatwierdzony, chyba że wyraźnie stwierdzono inaczej.",
    list: {
      "usfans-spreadsheet-list": {
        title: "Lista produktów arkusza USFans: jak przeglądać i porównywać",
        excerpt:
          "Lista produktów arkusza USFans łączy produkty, kategorie i sprzedawców w jednym widoku. Dowiedz się, jak ją przeglądać, porównywać opcje i zawężać produkty przed przejściem do sklepu.",
        tag: "Poradnik produktowy",
      },
      "usfans-seller-spreadsheet": {
        title: "Arkusz sprzedawców USFans: mądry research sprzedawców",
        excerpt:
          "Informacje o sprzedawcy mogą zadecydować o decyzji zakupowej. Ten poradnik wyjaśnia, jak arkusz sprzedawców pomaga przeglądać historię, porównywać opcje i dostrzegać sprzedawców wartych uwagi.",
        tag: "Poradnik sprzedawcy",
      },
      "how-to-use-usfans-spreadsheet": {
        title: "Jak korzystać z arkusza USFans: przewodnik krok po kroku",
        excerpt:
          "Nowy w arkuszu USFans? Ten przewodnik krok po kroku przeprowadzi Cię przez kategorie, filtry i kolumny, abyś przeszedł od pustego ekranu do krótkiej listy produktów bez zgadywania.",
        tag: "Poradnik dla początkujących",
      },
      "usfans-product-research": {
        title: "Poradnik researchu produktów USFans: znajdź szybciej to, czego potrzebujesz",
        excerpt:
          "Dobry research produktów oszczędza czas i pieniądze. Poznaj prosty proces porównywania produktów, sprawdzania szczegółów i tworzenia krótkiej listy przed zakupem.",
        tag: "Poradnik researchu",
      },
      "usfans-seller-research": {
        title: "Poradnik researchu sprzedawców USFans: rozpoznaj rzetelnych sprzedawców",
        excerpt:
          "Dokładna kontrola sprzedawcy zmniejsza ryzyko przed zakupem. Ten poradnik pokazuje, na co zwracać uwagę w historii sprzedawcy, opiniach i szczegółach wysyłki oraz jak oznaczyć coś podejrzanego.",
        tag: "Poradnik researchu",
      },
      "usfans-shipping-guide": {
        title: "Poradnik wysyłki USFans: opcje, koszty i dostawa",
        excerpt:
          "Opcje i koszty wysyłki różnią się znacznie w zależności od sprzedawcy i miejsca docelowego. Ten poradnik wyjaśnia popularne metody, co wpływa na czas dostawy i jak potwierdzić ostateczny koszt przed zamówieniem.",
        tag: "Poradnik wysyłki",
      },
      "usfans-coupon-guide": {
        title: "Poradnik kuponów USFans: znajdź i zastosuj bieżące oferty",
        excerpt:
          "Kupony pojawiają się i znikają, a nie każdy kod działa przy każdym zamówieniu. Dowiedz się, gdzie pojawiają się oferty, jak je stosować i co sprawdzić przed kasą.",
        tag: "Poradnik oszczędności",
      },
      "usfans-discount-code-guide": {
        title: "Poradnik kodów rabatowych USFans: gdzie pojawiają się okazje",
        excerpt:
          "Kody rabatowe mogą obniżyć sumę, ale tylko wtedy, gdy pasują do Twojego zamówienia. Ten poradnik wyjaśnia, gdzie pojawiają się kody, jak je testować i dlaczego kod może nie działać.",
        tag: "Poradnik oszczędności",
      },
      "usfans-warehouse-guide": {
        title: "Poradnik magazynu USFans: magazynowanie i dostawa wyjaśnione",
        excerpt:
          "Procesy magazynowe wpływają na szybkość wysyłki zamówienia. Dowiedz się, jak działa magazynowanie, co oznacza dla czasu dostawy i co sprawdzić w notatkach magazynowych.",
        tag: "Poradnik logistyki",
      },
      "usfans-qc-guide": {
        title: "Poradnik QC USFans: jak sprawdzić jakość przed zakupem",
        excerpt:
          "Zdjęcia i listy kontrolne kontroli jakości pomagają wychwycić problemy przed wysyłką. Ten poradnik wyjaśnia, na co zwracać uwagę, jak czytać zdjęcia QC i jak zgłaszać wątpliwości wcześnie.",
        tag: "Poradnik jakości",
      },
    },
  },
};